(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article-ttt"]) return;
  try {
    
  class ArticleShareTtt extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
    }

    /** Native share sheet when available (mobile), copy the link otherwise */
    #handleClick = async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-share-url]') : null;
      if (!(button instanceof HTMLElement)) return;

      const url = button.dataset.shareUrl ?? window.location.href;

      if (navigator.share) {
        try {
          await navigator.share({ title: button.dataset.shareTitle, url });
        } catch {}
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        const label = button.textContent;
        button.textContent = button.dataset.copiedLabel || label;
        setTimeout(() => (button.textContent = label), 2000);
      } catch {
        window.prompt('', url);
      }
    };
  }

  if (!customElements.get('article-share-ttt')) {
    customElements.define('article-share-ttt', ArticleShareTtt);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-ttt"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
